import { render } from "./MediaPage.vue?vue&type=template&id=53399dc0&ts=true"
import script from "./MediaPage.vue?vue&type=script&lang=ts"
export * from "./MediaPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__